<template>
    <div id="printClassStudent" class="container">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <Event_Tags_Component @tags="(val)=>$emit('setTags', val)"></Event_Tags_Component>
            <el-button-group>
                <el-button class="col-xs-2" v-on:click="$emit('AddComponentValue')">Add Student</el-button>
                <el-button class="col-xs-2" v-on:click="$emit('ClearSelectedItems')">Clear</el-button>
            </el-button-group>
        </div><hr>

        <div v-if="SelectedStudentListInt.length>0" class="datatable_group">
            <h5 class="text-left mb-3"><p class="font-weight-bold">Selected Student List</p></h5>
            <div class="datatable-form__submit text-right">
                <button class="btn btn-success searchbtn" id="btnPrint" v-on:click="$emit('PrintPreviewBtnClick')">Print&Preview</button><br>
            </div>
            <data-tables :data="SelectedStudentListInt"
                         @selection-change="$emit('changeSelection')" width="55" stripe tooltip-effect='light' border
                         ref="SelectedStudentListTable">
                <!--                    <el-table-column type="selection" width="55" :reserve-selection="true">-->
                <!--                    </el-table-column>-->
                <el-table-column v-for="item in SelectedStudentList"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :key="item.prop"
                                 sortable="custom">
                </el-table-column>
            </data-tables>
        </div>

    </div>
</template>

<script>
  import uiVariable from "../../config/uiVariable";
  import Event_Tags_Component from "../../components/Event_Tags_Component";
  export default {
    name: "StudentCard",
    components: { Event_Tags_Component },
    props: ["setTags","AddComponentValue","ClearSelectedItems","SelectedStudentListInt","PrintPreviewBtnClick","changeSelection","SelectedStudentList"],
    watch: {
      list:function (value){
        console.log("list",value)
      }
    },
    data() {
      return {
        uiVariable:uiVariable
      }
    },
    methods:{
    }
  }
</script>